import { apiConstants } from '../../apiConstant';
import { formDataCommonFunctionUnAuth } from '../../serviceCall';

/**
 * Saves agent-link "check back later" leads to Auth/WaitingUser.
 */
const submitAgentLinkLead = (data, callback, errorCallBack) => {
  return async () => {
    const formData = new FormData();
    const nameParts = (data.name || '').trim().split(/\s+/);
    const firstName = nameParts[0] || '';
    const lastName = nameParts.slice(1).join(' ') || '';

    formData.append('first_name_chr', firstName);
    formData.append('last_name_chr', lastName);
    formData.append('email_chr', data.email || '');
    formData.append('phone_code_id_int', data.phone_code_id_int || 1);
    formData.append('phone_number_int', data.phone || 0);
    formData.append('role_id_int', data.role_id_int || 2);
    if (data.zip_code_int) {
      formData.append('zip_code_int', data.zip_code_int);
    }
    if (data.agent_link_problem_chr) {
      formData.append('agent_link_problem_chr', data.agent_link_problem_chr);
    }
    if (data.agent_link_source_chr) {
      formData.append('agent_link_source_chr', data.agent_link_source_chr);
    }

    formDataCommonFunctionUnAuth(formData, apiConstants.AUTH.WAITING_USER)
      .then((response) => {
        callback?.(response);
      })
      .catch((error) => {
        errorCallBack?.(error?.response || error);
      });
  };
};

export default submitAgentLinkLead;
